'use client';

import { clsx } from 'clsx';
import { FC } from 'react';
import {
  AccordionDetails,
  AccordionSummary,
  BareAccordion,
} from 'atoms/BareAccordion';
import { Icon, IconType } from 'atoms/Icon';
import { StoryBlokLink } from 'atoms/StoryBlokLink';
import { Span } from 'atoms/Typography';
import { gtmPushBurgerMenuMobileFirstLevel } from 'modules/gtm/modules/sections/navigation/navigation';
import { NavigationItemSecondLevel } from './NavigationItemSecondLevel';
import { flattenFlyout } from './helpers';
import type { INavigationItemProps } from './types';
import styles from './styles.module.css';

export const NavigationItem: FC<INavigationItemProps> = ({
  navigationItem,
  isActive,
  expandedAccordion,
  handleAccordionChange,
}) => {
  if (
    navigationItem.flyoutColumns?.length === 0 &&
    navigationItem.children?.length === 0
  ) {
    return navigationItem?.url ? (
      <div
        className={clsx(styles.linkContainer, styles.spacing)}
        key={navigationItem._uid}
      >
        <StoryBlokLink
          className={clsx(styles.link, styles.text, isActive && styles.current)}
          link={navigationItem.url}
        >
          <Span>{navigationItem?.title}</Span>
          <Icon className={styles.icon} type={IconType.arrowDown} />
        </StoryBlokLink>
      </div>
    ) : null;
  }
  const children = navigationItem?.children ?? [];
  const navigationSecondLevelItems = [
    ...children,
    ...flattenFlyout(navigationItem),
  ];

  const handleNavigationFirstLevelClick = (navigationItem: string) => {
    gtmPushBurgerMenuMobileFirstLevel(navigationItem);
  };

  return (
    <BareAccordion
      key={navigationItem._uid}
      classes={{
        root: styles.accordionRoot,
      }}
    >
      <AccordionSummary
        classes={{
          root: clsx(styles.summaryRoot, styles.spacing),
          content: clsx(
            styles.summaryContent,
            styles.text,
            isActive && styles.current,
          ),
          expanded: clsx(styles.expanded),
        }}
        expandIcon={
          <Icon type={IconType.arrowDown} className={clsx(styles.arrow)} />
        }
        onClick={() =>
          handleNavigationFirstLevelClick(navigationItem?.title || '')
        }
      >
        {navigationItem?.title}
      </AccordionSummary>
      <AccordionDetails classes={{ root: styles.accordionDetails }}>
        {navigationSecondLevelItems.map((secondLevelItem) => (
          <NavigationItemSecondLevel
            key={secondLevelItem._uid}
            firstLevelItem={navigationItem}
            secondLevelItem={secondLevelItem}
            expandedAccordion={expandedAccordion}
            handleAccordionChange={handleAccordionChange}
          />
        ))}
      </AccordionDetails>
    </BareAccordion>
  );
};
